var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"right":"","open-on-click":"","open-on-hover":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("\n        "+_vm._s(_vm.icon)+"\n      ")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }